(() => {
  const initialize = async (section) => {
    if (section.dataset.catalogLoaded) return;
    section.dataset.catalogLoaded = 'true';
    const config = JSON.parse(section.querySelector('.rcwmg__catalog').textContent);
    const grid = section.querySelector('.rcwmg__grid');
    const brandIndex = config.brands.indexOf(config.brand);
    const parts = config.parts.filter(part => part.brands.includes(brandIndex));
    try {
      const batches = [];
      // Keep concurrent requests bounded, including brands with large catalogs.
      for (let i = 0; i < parts.length; i += 4) {
        batches.push(...await Promise.all(parts.slice(i, i + 4).map(async part => {
          const response = await fetch(part.url, { credentials: 'omit', signal: AbortSignal.timeout(20000) });
          if (!response.ok) throw Error('catalog');
          const rows = await response.json();
          if (!Array.isArray(rows) || rows.length !== part.count) throw Error('catalog');
          return rows;
        })));
      }
      const rows = batches.flat().filter(row => row[0] === brandIndex && row[6] === config.family)
        .sort((a, b) => a[1].localeCompare(b[1]));
      if (!rows.length) return; // Preserve the server-rendered fallback.
      const node = (tag, className, text) => {
        const value = document.createElement(tag);
        value.className = className;
        if (text !== undefined) value.textContent = text;
        return value;
      };
      let shown = 0;
      const more = node('button', 'btn rcwmg__more', config.text.more);
      more.type = 'button';
      const appendPage = () => {
        for (const row of rows.slice(shown, shown + 48)) {
          if (typeof row[12] !== 'string') throw Error('model link');
          const modelUrl = row[12].replace(/^\/pages\/saat-modelleri\//, '/pages/saatler/');
          if (modelUrl && !modelUrl.startsWith('/pages/saatler/')) throw Error('model link');
          const card = node(modelUrl && row[11] !== 2 ? 'a' : 'article', 'rcwmg__card');
          if (modelUrl && row[11] !== 2) card.href = modelUrl;
          const media = node('div', 'rcwmg__media');
          const source = row[8] || row[9];
          if (source) {
            const url = new URL(source);
            if (url.protocol === 'https:' && ['cdn.shopify.com'].includes(url.hostname)) {
              const image = node('img', '');
              if (url.hostname === 'cdn.shopify.com') url.searchParams.set('width', '420');
              image.src = url.href; image.alt = row[2]; image.loading = 'lazy';
              image.width = 640; image.height = 640;
              image.addEventListener('error', () => { image.hidden = true; }, { once: true });
              media.append(image);
            }
          }
          const content = node('div', 'rcwmg__content');
          content.append(node('p', 'rcwmg__reference', row[1]), node('h3', '', row[2]));
          const measurements = node('dl', '');
          for (const [value, label] of [[row[3], config.text.case], [row[4], config.text.lug]]) {
            if (value === null) continue;
            const pair = node('div', '');
            pair.append(node('dt', '', label), node('dd', '', value + ' mm'));
            measurements.append(pair);
          }
          content.append(measurements);
          if (row[11] === 1 || row[11] === 2) content.append(node('span', 'rcwmg__badge', row[11] === 1 ? config.text.unsupported : config.text.review));
          if (row[11] === 2) {
            const contact = node('button', 'btn', config.text.contact);
            contact.type = 'button'; contact.dataset.rcContactOpen = '';
            contact.dataset.watch = config.brand + ' ' + row[2] + ' · ' + row[1];
            contact.setAttribute('aria-haspopup', 'dialog'); content.append(contact);
          }
          if (modelUrl) {
            const link = node(row[11] === 2 ? 'a' : 'span', 'rcwmg__link', config.text.view + ' →');
            if (row[11] === 2) link.href = modelUrl;
            content.append(link);
          }
          card.append(media, content); grid.append(card);
        }
        shown += 48;
        more.hidden = shown >= rows.length;
      };
      grid.replaceChildren();
      appendPage();
      more.addEventListener('click', appendPage);
      grid.after(more);
    } catch (_) {
      const message = document.createElement('p');
      message.textContent = config.text.error;
      grid.after(message);
    }
  };
  const scan = () => document.querySelectorAll('[data-rc-watch-family]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
